
import { Payload } from "@/types/profile";

export const certificatePayloads: Payload[] = [
  // Certificates payloads
  {
    id: "certificates",
    name: "Certificates",
    description: "Install certificates on devices",
    category: "Security",
    supportedPlatforms: ["macos", "ios", "ipados", "tvos"],
    configFields: [
      {
        id: "certificate",
        name: "Certificate",
        type: "file",
        required: true,
        description: "Certificate file (.cer, .p12)"
      },
      {
        id: "password",
        name: "Certificate Password",
        type: "text",
        required: false,
        description: "Password for the certificate (if required)"
      }
    ]
  },
  
  // Identity Preference payloads
  {
    id: "identity-preference",
    name: "Identity Preference",
    description: "Configure identity preference settings",
    category: "Security",
    supportedPlatforms: ["macos"],
    configFields: [
      {
        id: "identityName",
        name: "Identity Name",
        type: "text",
        required: true,
        description: "Name of the identity"
      },
      {
        id: "certificateIdentifier",
        name: "Certificate Identifier",
        type: "text",
        required: true,
        description: "Identifier of the certificate"
      }
    ]
  },
  
  // SCEP payloads
  {
    id: "scep",
    name: "SCEP",
    description: "Configure Simple Certificate Enrollment Protocol",
    category: "Security",
    supportedPlatforms: ["macos", "ios", "ipados", "tvos"],
    configFields: [
      {
        id: "scepURL",
        name: "SCEP URL",
        type: "text",
        required: true,
        description: "URL of the SCEP server"
      },
      {
        id: "scepName",
        name: "SCEP Name",
        type: "text",
        required: true,
        description: "Name for the SCEP configuration"
      },
      {
        id: "challengePassword",
        name: "Challenge Password",
        type: "text",
        required: false,
        description: "Challenge password for SCEP"
      }
    ]
  }
];
